// @flow

import Config from './config';

export function decodeURI(str) {
  return decodeURIComponent(str);
}

export function encodeURI(str) {
  return encodeURIComponent(str);
}

export function getObjectOfReferrer(ref, hostname, hasReferrer) {
  const { url } = Config.auth.strSplitter;
  const getReferrer = ref !== '' ? ref.match(/:\/\/(.[^/]+)/) : null;
  const getRefProtocol = getReferrer ? getReferrer.input.split(url)[0] : null;
  const getRefDomain = getReferrer ? getReferrer[0] : null;
  // const getRefHostname = getReferrer ? getRefDomain.split(url)[1] : null;
  const isReferrer = getReferrer ? getReferrer.toString().indexOf(hostname) < 0 : null;
  const referrer = isReferrer ? getRefProtocol + getRefDomain : null;
  const rHost = !referrer && hasReferrer ? hasReferrer : referrer;

  return { rHost };
}

export function mergeObjects(
  objectAssignInto,
  objectAssignFrom,
) {
  return Object.assign(objectAssignInto, objectAssignFrom);
}

export function getURLSearchParams(queryString) {
  const urlParams = new URLSearchParams(queryString);
  const options = {};
  if (!queryString) {
    return options;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const param of urlParams) {
    mergeObjects(options, { [param[0]]: param[1] });
  }
  return options;
}

export function setCookie(cookie, domain, path, date) {
  if (!cookie) {
    return false;
  }
  const keys = Object.keys(cookie);
  const getDate = date || new Date(new Date().getTime() + 60 * 1000);

  return keys.forEach((key) => {
    const cookies = `${key}=${cookie[key]}; domain=${domain || ''}; path=${path ||
      '/'}; expires=${getDate.toUTCString()}`;
    document.cookie = cookies;
  });
}

export function overrideObjectWithEmptyProperty(entity) {
  const filterEmptyFields = Object.keys(entity).filter((item) => entity[item] != null);

  let object = {};

  filterEmptyFields.forEach((item) => {
    object = { ...object, ...{ [item]: entity[item] } };
  });
  return object;
}
